<template>
    <div>
        <div class="box">
            <!-- <b-tabs expanded type="is-toggle"> -->
            <!-- CHOOSE IMAGE -->
            <!-- <b-tab-item icon="image" label="Media"> -->
            <Gallery />
            <!-- </b-tab-item> -->

            <!-- UPLOAD IMAGE -->
            <!-- <b-tab-item icon="upload" label="Upload Image"> -->
            <!-- <b-field :message="{ 'Please select a folder': !selectedFolder }" :type="{ 'is-danger': !selectedFolder }" label="Folder">
                        <folderAutocomplete v-model="selectedFolder" />
                    </b-field>
                    <b-field>
                        <b-upload accept="image/*" drag-drop expanded v-model="form.image">
                            <section class="section">
                                <div class="content has-text-centered">
                                    <p>
                                        <b-icon icon="upload" size="is-large"></b-icon>
                                    </p>
                                    <p>Drop your image here or click to upload</p>
                                </div>
                            </section>
                        </b-upload>
                    </b-field>
                    <div class="tags">
                        <span class="tag is-primary" v-if="form.image">
                            {{ form.image.name }}
                            <button @click="form.image = null" class="delete is-small" type="button"></button>
                        </span>
                    </div>
                    <b-field expanded>
                        <b-button @click="doUpload" expanded type="is-primary">Upload</b-button>
                    </b-field> -->
            <!-- </b-tab-item> -->
            <!-- </b-tabs> -->
        </div>
    </div>
</template>

<script>
// import vForm from '../../../plugins/vForm';
import Gallery from "../../../components/Files/GalleryComponent.vue";
// import folderAutocomplete from "../../../components/folderAutocomplete";

export default {
    components: {
        Gallery,
        // folderAutocomplete,
    },
    data() {
        return {
            // activeTab: 0,
            // itemName: "Media",
            // selectedFolder: null,
            // viewFolder: null,
            // image: null,
            // folder_id: null,
            // images: [],
            // page: 1,
            // totalPages: 1,
            // query: "",
            // isLoading: false,
            // isViewImage: false,
            // viewImage: null,
        };
    },
    methods: {
        async init() {
            // try {
            // 	let tmp = await this.$http.get(`/folder`)
            // 	this.folders = tmp.data
            // } catch (e) {
            // 	return
            // 	// TODO Do something
            // }
        },
        // async doUpload() {
        //     if (this.form.folders_id === null || this.form.image === null) {
        //         this.swal.fire("Failed!", "Please choose a folder and image file to upload.", "warning");
        //         return;
        //     }
        //     try {
        //         await this.form.post("/images", {
        //             // Transform form data to FormData
        //             transformRequest: [
        //                 (data) => {
        //                     const formData = new FormData();
        //                     Object.keys(data).forEach((key) => {
        //                         if (data[key] === undefined || data[key] === null) {
        //                             return;
        //                         }
        //                         formData.append(key, data[key]);
        //                     });
        //                     return formData;
        //                 },
        //             ],
        //         });
        //         this.toast.fire({
        //             icon: "success",
        //             title: "Image was uploaded successfully.",
        //         });
        //         this.activeTab = 0;
        //         this.viewFolder = this.selectedFolder;
        //         this.loadFolder();
        //     } catch (e) {
        //         this.toast.fire({
        //             icon: "error",
        //             title: "Image was not uploaded.",
        //         });
        //     }
        // },
        // async destroy(item) {
        //     this.swal
        //         .fire({
        //             title: "Attention",
        //             text: "Are you sure you want to delete image ID: " + item.id + " ?",
        //             icon: "warning",
        //             showCancelButton: true,
        //             confirmButtonText: "Yes",
        //         })
        //         .then((result) => {
        //             if (result.value) {
        //                 this.isLoading = true;
        //                 // Send request to server
        //                 this.form
        //                     .delete("/images/" + item.id)
        //                     .then(() => {
        //                         this.swal.fire("Deleted!", "Your " + this.itemName.toLowerCase() + " has been deleted.", "success");
        //                         this.loadFolder();
        //                         this.isLoading = false;
        //                     })
        //                     .catch((res) => {
        //                         this.swal.fire("Failed!", res.response.data, "warning");
        //                         this.isLoading = false;
        //                     });
        //             }
        //         });
        // },
        // async loadFolder(page = 1) {
        //     this.isLoading = true;
        //     let tmp = await this.$http.get(`/folder/${this.viewFolder.id}/files?page=${page}&search=${this.query}`);
        //     this.images = tmp.data;
        //     this.isLoading = false;
        // },
    },
    computed: {},
    watch: {
        // selectedFolder: function () {
        //     this.form.folders_id = this.selectedFolder.id;
        // },
        // viewFolder: function (update) {
        //     if (update) {
        //         this.loadFolder();
        //     }
        //     this.query = "";
        //     this.page = 1;
        // },
    },
    mounted() {
        // this.init();
    },
};
</script>


<style scoped>
.card-footer {
    display: none;
}

.card:hover .card-footer {
    border-top: none;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    background-color: #ffffff00;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
}

.fit {
    object-fit: cover;
}

.pointer {
    cursor: pointer;
}
</style>